"use strict";

var _require = require('../../../helpers'),
    computeExactQuantity = _require.computeExactQuantity,
    computeRoundedQuantity = _require.computeRoundedQuantity,
    computeCopies = _require.computeCopies;

module.exports = function (accumulator, order, product, component, options, settings) {
  var exactNum = computeExactQuantity(component);
  var rounded_quantity = computeRoundedQuantity(component);
  var copies = computeCopies(component);
  var up = parseInt(component.up, 10);

  if (settings.uncustomizable) {
    return rounded_quantity;
  }

  if (component.has_variable_data) {
    return exactNum + ' (' + up + 'up, ' + copies + ' pages, 1 copy each page) - VARIABLE DATA';
  }

  return "".concat(rounded_quantity, " (").concat(up, "up, ").concat(copies, " ").concat(copies > 1 ? 'copies' : 'copy', ")");
};